module.exports = __webpack_public_path__ + "static/media/agent-off.68e31782.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/agent-off.svg
// module id = 745
// module chunks = 0